// Open timeline on mobile on click

var timelineMobile = function() {
    var timelineBtnSelector = $('.o-js-toggle-timeline-btn')
    var containerSelector = $('.o-js-timeline-container')

    openContainer((containerSelector).first())
    timelineBtnSelector.on('click', function(){
        var container = $(this).closest(containerSelector)
        if (container.hasClass('active')) {
            closeContainer(container)
        } else {
            openContainer(container)
        }
        closeContainer((containerSelector).not(container))
    })
}

var openContainer = function(element) {
    var displayedBlockSelector = $('.o-js-timeline-displayed-block')
    $(element).addClass('active').find(displayedBlockSelector).slideDown(400)
}

var closeContainer = function(element) {
    var displayedBlockSelector = $('.o-js-timeline-displayed-block')
    $(element).removeClass('active').find(displayedBlockSelector).slideUp(400)
}

var timelineArrow = function() {
    $(".tv-partnersBlock-arrow ").on('click', function() {
        var rightBlock = $(".tv-timelineBlock__right-block"),
        x;
        if ($(this).hasClass("tv-partnersBlock-arrow--right")) {
            x = ((rightBlock.width() / 2)) + rightBlock.scrollLeft();
            rightBlock.animate({
                scrollLeft: x,
            }, 1000)
        } else {
            x = ((rightBlock.width() / 2)) - rightBlock.scrollLeft();
            rightBlock.animate({
                scrollLeft: -x,
            }, 1000)
        }
    })
}

$(document).ready(function() {
    timelineMobile();
    openContainer();
    closeContainer();
    timelineArrow();
});